export default __webpack_public_path__ + "static/media/defiyield0.1dd891fd.jpg";